import React from 'react'
import {
  Radio,
  FormControl,
  FormControlLabel,
  FormControlProps,
  FormGroup,
  FormGroupProps,
  FormLabel,
  FormControlLabelProps,
  RadioProps,
  FormLabelProps,
} from '@material-ui/core'
import { MenuOption } from '../Menus'
import { isEqual } from 'lodash-es'


export type RadioFormGroupProps<T> = {
  name?: React.ReactNode
  value: T
  onChange: (value: T) => void
  options: MenuOption<T>[]
  areValuesEqual?: (a: T, b: T) => boolean
  FormGroupProps?: FormGroupProps
  FormLabelProps?: FormLabelProps
  FormControlLabelProps?: Partial<FormControlLabelProps>
  RadioProps?: Partial<Omit<RadioProps, 'checked' | 'onChange'>>
  scrollable?: boolean
  maxHeight?: string | number
} & Partial<Pick<FormControlProps, 'color' | 'disabled' | 'size'>>

export function RadioFormGroup<T>({
  name,
  value,
  options,
  onChange,
  areValuesEqual = isEqual,
  FormGroupProps = {},
  FormLabelProps = {},
  FormControlLabelProps = {},
  RadioProps = {},
  scrollable,
  maxHeight,
  ...props
}: RadioFormGroupProps<T>): JSX.Element {
  const formGroupStyle: React.CSSProperties | undefined = (
    scrollable && maxHeight ?
      { maxHeight, overflowY: 'auto', flexWrap: 'nowrap', ...FormGroupProps.style } :
      FormGroupProps.style
  )
  return (
    <FormControl color='secondary' component='fieldset' {...props}>
      { name && <FormLabel {...FormLabelProps}>{name}</FormLabel> }
      <FormGroup {...FormGroupProps} style={formGroupStyle}>
        { options.map( (option, i) => {
          const isSelected = areValuesEqual(value, option.value)
          return (
            <FormControlLabel
              key={i}
              label={option.label}
              disabled={option.disabled}
              control={
                <Radio
                  {...RadioProps}
                  checked={isSelected}
                  onChange={(): void => {
                    onChange(option.value)
                  }} />
              }
              {...FormControlLabelProps} />
          )
        })}
      </FormGroup>
    </FormControl>
  )
}
